module.exports = "/_next/static/images/4adec5bc70869cf7b2b911788b3912cf-open-graph-large.jpg.webp";